import Header from "components/Headers/Header";
import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getReadNotifications } from "store/actions/notificationsAction";
import moment from "moment";
import { getUnreadNotifications } from "store/actions/notificationsAction";
import { markNotificationAsRead } from "store/actions/notificationsAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import TabsComponent from "components/TabsComponent";

const Notifications = () => {
  const { user } = useSelector((state) => state.auth);
  console.log("user: ", user);
  const {
    readNotifications,
    lastVisible,
    hasMoreDocument,
    unreadNotifications,
    unreadLastVisible,
    unreadHasMore,
  } = useSelector((state) => state.notifications);
  console.log("unreadLastVisible: ", unreadLastVisible);
  console.log("unreadHasMore: ", unreadHasMore);
  console.log("lastVisible: ", lastVisible);
  console.log("hasMoreDocument: ", hasMoreDocument);
  console.log("readNotifications: ", readNotifications);
  console.log("unreadNotifications: ", unreadNotifications);
  const [activeTab, setActiveTab] = useState("Unread");
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const handleReadNotification = () => {
    setIsLoading(true);
    dispatch(
      getReadNotifications(user?.id, "", () => {
        setIsLoading(false);
      })
    );
  };

  const formatType = (type = "") => {
    return type
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleReadLoadMore = () => {
    if (hasMoreDocument) {
      setIsLoading(true);
      dispatch(
        getReadNotifications(user?.id, lastVisible, () => {
          setIsLoading(false);
        })
      );
    }
  };

  const handleUnreadLoadMore = () => {
    if (unreadHasMore) {
      setIsLoading(true);
      dispatch(
        getUnreadNotifications(user?.id, unreadLastVisible, () => {
          setIsLoading(false);
        })
      );
    }
  };

  const handleNotificationCard = (item) => {
    dispatch(
      markNotificationAsRead(item.id, user?.id, () => {
        if (item.type === "contest") {
          history.push(`/school/contests?contestId=${item?.contestId}`);
        }
      })
    );
  };

  const tabs = [
    {
      id: "Unread",
      title: "Unread",
      content: (
        <>
          {isLoading ? (
            <div className="text-center">
              <div className="text-center" role="status">
                <Spinner size="sm" />
              </div>
            </div>
          ) : unreadNotifications?.length > 0 ? (
            unreadNotifications.map((item) => (
              <Card
                className="mb-3"
                key={item.id}
                onClick={() => {
                  handleNotificationCard(item);
                }}
                style={{ cursor: "pointer" }}
              >
                <CardBody>
                  <Row>
                    {/* <Col xs="auto">
                      <img
                        src={
                          item?.athleteData?.player_image?.url ||
                          "/placeholder.png"
                        }
                        alt="profile"
                        className="rounded-circle"
                        style={{ width: 50, height: 50, objectFit: "cover" }}
                      />
                    </Col> */}
                    <Col>
                      <p className="mb-1 fw-bold">
                        {`Admin has approved the ${
                          item?.contestData?.sportName
                        } contest. It begins on ${moment(
                          item?.contestData?.startDate.toDate?.()
                        ).format("DD MMM YYYY")}.`}
                      </p>
                      <p
                        className="mb-0 text-muted"
                        style={{ fontSize: "0.85rem" }}
                      >
                        {moment(item?.createdAt?.toDate?.()).fromNow()}
                      </p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))
          ) : (
            <p className="text-center text-muted mt-3">
              No Unread notifications.
            </p>
          )}
        </>
      ),
      onClick: () => {},
    },
    {
      id: "Read",
      title: "Read",
      content: (
        <>
          {isLoading ? (
            <div className="text-center">
              <Spinner size="sm" />
            </div>
          ) : readNotifications?.length > 0 ? (
            readNotifications.map((item) => (
              <Card className="mb-3" key={item.id}>
                <CardBody>
                  <Row>
                    {/* <Col xs="auto">
                      <img
                        src={
                          item?.athleteData?.player_image?.url ||
                          "/placeholder.png"
                        }
                        alt="profile"
                        className="rounded-circle"
                        style={{ width: 50, height: 50, objectFit: "cover" }}
                      />
                    </Col> */}
                    <Col>
                      <p className="mb-1 fw-bold">
                        {`Admin has approved the ${
                          item?.contestData?.sportName
                        } contest. It begins on ${moment(
                          item?.contestData?.startDate.toDate?.()
                        ).format("DD MMM YYYY")}.`}
                      </p>
                      <p
                        className="mb-0 text-muted"
                        style={{ fontSize: "0.85rem" }}
                      >
                        {moment(item?.createdAt?.toDate?.()).fromNow()}
                      </p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))
          ) : (
            <p className="text-center text-muted mt-3">
              No read notifications.
            </p>
          )}
        </>
      ),
      onClick: () => {
        handleReadNotification();
      },
    },
  ];

  return (
    <>
      <Container className="mt-5" fluid>
        <h2 className="m-5">Notification</h2>
        <Row>
          <div className="col">
            <Card className="shadow">
              <TabsComponent
                activeTab={activeTab}
                toggleTab={toggleTab}
                tabs={tabs}
                additionalText={true}
              />
            </Card>
          </div>
        </Row>
        <Row className="mt-3 d-flex justify-content-center">
          {activeTab === "Unread" ? (
            <Button
              onClick={handleUnreadLoadMore}
              color="primary"
              disabled={!unreadHasMore || isLoading}
            >
              Load more
            </Button>
          ) : (
            <Button
              onClick={handleReadLoadMore}
              color="primary"
              disabled={!hasMoreDocument || isLoading}
            >
              Load more
            </Button>
          )}
        </Row>
      </Container>
    </>
  );
};

export default Notifications;
